import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { Status } from 'model/alerts.model';
import { DealsService } from 'service/deals.service';

export type Service = {
  serviceName: string;
  ceilingRate: number;
  targetPrice: number;
  floorRate: number;
};

interface State {
  services: Service[];
  totalFloorRate: number;
  totalCeilingRate: number;
  totalTargetPrice: number;
  zone: 'AMBER' | 'GREEN' | 'RED';
  loading: Status;
  pricingHealth: number;
}

const initialState: State = {
  services: [],
  totalCeilingRate: 0,
  totalFloorRate: 0,
  totalTargetPrice: 0,
  zone: 'GREEN',
  loading: 'idle',
  pricingHealth: 0,
};

export const fetchPriceIntelligenceAndServices = createAsyncThunk(
  'deal/fetchPriceIntelligenceAndServices',
  async (id: string) => {
    const data = await DealsService.getPricingIntelligenceAndServices(id);
    return data;
  },
);

const dealsSlice = createSlice({
  name: 'deals',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(fetchPriceIntelligenceAndServices.fulfilled, (state, action) => {
      state.services = action.payload.services;
      state.totalCeilingRate = action.payload.totalCeilingRate;
      state.totalTargetPrice = action.payload.totalTargetPrice;
      state.totalFloorRate = action.payload.totalFloorRate;
      state.zone = action.payload.zone;
      state.pricingHealth = action.payload.pricingHealth;

      state.loading = 'complete';
    });
    builder.addCase(fetchPriceIntelligenceAndServices.pending, (state, action) => {
      state.loading = 'in-progress';
    });
  },
});

// export const {} = dealsSlice.actions;
export default dealsSlice.reducer;
